import { render, staticRenderFns } from "./editcustomer.vue?vue&type=template&id=54e3c606&scoped=true&"
import script from "./editcustomer.vue?vue&type=script&lang=js&"
export * from "./editcustomer.vue?vue&type=script&lang=js&"
import style0 from "./editcustomer.vue?vue&type=style&index=0&id=54e3c606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e3c606",
  null
  
)

export default component.exports